import { observer } from 'mobx-react-lite'
import { useState, useEffect } from 'react'
import { BoolProps } from '../../../../model/Boolean'
import { ModalWindow } from '../../../../component/common/analog/template/ModalWindow'
import { AppBox } from '../../../../component/common/analog/molecule/AppBox'
import { AppButton } from '../../../../component/common/analog/molecule/button/AppButton'
import { AppTextField } from '../../../form/component/analog/AppTextField'
import { UpdatePortfolioDto, PortfolioResponse, PortfolioType } from '../../model/portfolio'
import { useLocalizationStore } from '../../../localization/store/localization.store'
import { AppDivider } from 'src/component/common/analog/molecule/AppDivider'

export interface BioFormModalProps extends BoolProps {
  onSubmit: (data: UpdatePortfolioDto) => Promise<void>
  initialData?: PortfolioResponse
  isEditing?: boolean
}

export const BioFormModal = observer((props: BioFormModalProps) => {
  const { translation } = useLocalizationStore()

  const [content, setContent] = useState('')

  useEffect(() => {
    if (props.isTrue) {
      setContent(props.initialData?.content || '')
    }
  }, [props.isTrue, props.initialData])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    if (!content.trim()) {
      return
    }

    await props.onSubmit({
      type: PortfolioType.BIO,
      content: content.trim(),
    })

    setContent('')
  }

  const handleClose = () => {
    setContent('')
    props.makeFalse()
  }

  return (
    <ModalWindow
      modalProps={{
        open: props.isTrue,
        onClose: handleClose,
        PaperProps: {
          sx: {
            maxWidth: { xs: '80%', md: '50%', lg: '30%' },
            borderRadius: '10px',
          },
        },
      }}
      titleProps={{
        textValue: props.isEditing
          ? `Edit ${translation.pages.profile.portfolioModal.bio.label()}`
          : `Add ${translation.pages.profile.portfolioModal.bio.label()}`,
      }}
    >
      <form onSubmit={handleSubmit}>
        <AppBox sx={styles.container}>
          <AppTextField
            label={translation.pages.profile.portfolioModal.content.label()}
            placeholder={translation.pages.profile.portfolioModal.bio.placeholder()}
            value={content}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setContent(e.target.value)}
            multiline
            rows={4}
            fullWidth
            required
            sx={styles.textField}
          />

          <AppDivider />

          <AppBox sx={styles.buttonContainer}>
            <AppButton
              fontSize={12}
              textValue={translation.buttons.cancel()}
              variant="light"
              onClick={handleClose}
              type="button"
            />
            <AppButton
              fontSize={12}
              textValue={translation.buttons.save()}
              variant="contained"
              type="submit"
              disabled={!content.trim()}
            />
          </AppBox>
        </AppBox>
      </form>
    </ModalWindow>
  )
})

const styles = {
  container: {
    flexDirection: 'column',
    gap: 10,
    width: '100%',
  },
  textField: {
    '& .MuiInputBase-root': {
      minHeight: 100,
    },
    margin: 0,
  },
  buttonContainer: {
    gap: 10,
    justifyContent: 'flex-end',
  },
}